import React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import Avatar from '../../components/Avatar';
import Tooltip from '../../components/Tooltip';
import DownloadIcon from '../../assets/images/download-15x15.svg';
import { __, bytesToSize, dateTimeFrom } from '../../core/utils';
import styles from '../../styles/flyouts/files/FileFlyout.scss';

const Versions = ({ versions, collapsed, onDownload }) => (
  <div className={classNames(styles.sectionContent, collapsed && styles.collapsed)}>
    <div className={styles.tableHeader}>
      <span>{__('files.table.version', {}, 'Version')}</span>
      <span>{__('files.table.uploaded-by', {}, 'Uploaded by')}</span>
      <span>{__('files.table.uploaded-at', {}, 'Uploaded at')}</span>
      <span>{__('files.table.size', {}, 'Size')}</span>
      <span />
    </div>
    {_.map(versions, (version) => (
      <div className={styles.tableRow} key={version.id}>
        <span>
          {'V' + version.version}
          {version.current && (
            <small>{__('files.flyout.current', {}, 'Current')}</small>
          )}
        </span>
        <span className={styles.user}>
          {version.uploaded_by && (
            <>
              <Avatar
                avatar_url={version.uploaded_by.avatar_url}
                name={version.uploaded_by.name}
                size={22}
              />
              {version.uploaded_by.name}
            </>
          )}
        </span>
        <span>{dateTimeFrom(version.uploaded_at)}</span>
        <span>{version.size ? bytesToSize(version.size) : '—'}</span>
        <span className={styles.rowAction}>
          <Tooltip text={__('attachments.menu.download', {}, 'Download')}>
            <DownloadIcon onClick={() => onDownload(version, true)} />
          </Tooltip>
        </span>
      </div>
    ))}
  </div>
);

export default Versions;
